import {Component, computed, input} from '@angular/core';
import {RouterLink} from '@angular/router';
import {STEP_PHASE_MAP} from '../../models/step-phase-map';
import {IackathonSave} from '../../services/iackathon-saves.service';

@Component({
  selector: 'app-iackathon-group',
    imports: [
        RouterLink
    ],
  templateUrl: './iackathon-group.component.html',
  styleUrl: './iackathon-group.component.scss',
})
export class IackathonGroupComponent {
    save = input.required<IackathonSave>();

    protected readonly groupName = computed(() => this.save().attributes.content.state.group_name)
    protected readonly saveAuthor = computed(() => this.save().attributes.content.state.author_name)
    protected readonly members = computed(() => this.save().attributes.content.state.members)
    protected readonly indexCurrentPhase = computed(() => this.getCurrentPhaseIndex(this.save().attributes.content.state.current_step_id))

    private getCurrentPhaseIndex(current_step_id: string): number {
        if (current_step_id in STEP_PHASE_MAP === false) {
            return 0;
        }

        const phase = STEP_PHASE_MAP[current_step_id];
        const indexStr = phase.replace('phase_', '');

        switch (indexStr) {
            case '01': return 1;
            case '02': return 2;
            case '03': return 3;
            case '04': return 4;
            default: return 0;
        }

    }
}
